import React  from 'react';
import {
  Button,
  ModalDialog,
}             from '@components/index';
import styled from 'styled-components';

interface IProps {
  open      : boolean;
  onCancel  : () => void;
  onConfirm : () => void;
}

const ButtonWrapper = styled.div`
  width           : 100%;
  display         : flex;
  justify-content : space-evenly;
`;

export const ConfirmDialog: React.FC<IProps> = ({
  open,
  onCancel,
  onConfirm,
}: IProps): JSX.Element => (
  <ModalDialog
    open      = {open}
    title     = " "
    content   = "Are you sure you want to delete this line item?"
    onClose   = {onCancel}
    fontSize  = "18px"
    textAlign = "center"
    textColor = "secondary"
    actions   = {(
      <ButtonWrapper>
        <Button
          label   = "Cancel"
          variant = "outlined"
          width   = "180px"
          onClick = {onCancel}
        />
        <Button
          label   = "Yes, Delete"
          width   = "180px"
          onClick = {onConfirm}
        />
      </ButtonWrapper>
    )}
  />
);
